export default __webpack_public_path__ + "static/media/old-paper.70c5f0b9.jpg";